/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Order_Events_By_TimeInputs */



/**
* | output |
* | --- |
* | "Order Events by Time" |
*
* @param {Shortcut_Keys_Name_Order_Events_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_order_events_by_time = /** @type {((inputs?: Shortcut_Keys_Name_Order_Events_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Order_Events_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trier les evenements par temps")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse nach Zeit sortieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina gli eventi per ora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сортировать события по времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordenar eventos por tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按时间排序事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間順にイベントを並べ替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय के अनुसार घटनाओं को क्रमबद्ध करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ordenar eventos por horário")
	return /** @type {LocalizedString} */ ("Order Events by Time")
});